import { ReactNode, useCallback, useEffect, useState } from "react";

import { getTags } from "@/api/endpoints/tags";
import TagContext from "@/contexts/TagContext";
import { Tag } from "@/types/Tag";

const sortTags = (tags: Tag[]) => {
  const favourite = tags.filter((tag) => tag.name === "favorited") || [];
  const others = tags.filter((tag) => tag.name !== "favorited");
  return [...favourite, ...others];
};

const TagProvider = ({ children }: { children: ReactNode }) => {
  const [organizationTags, setOrganizationTags] = useState<Tag[]>([]);

  const fetchOrganizationTags = useCallback(() => {
    getTags()
      .then(({ data, ok }) => {
        if (ok && data?.length > 0) {
          setOrganizationTags(sortTags(data));
        }
      })
      .catch((error) => {
        throw error;
      });
  }, []);

  useEffect(() => {
    fetchOrganizationTags();
  }, [fetchOrganizationTags]);

  return (
    <TagContext.Provider
      value={{
        organizationTags,
        setOrganizationTags,
        fetchOrganizationTags,
      }}
    >
      {children}
    </TagContext.Provider>
  );
};

export default TagProvider;
